// extracted by mini-css-extract-plugin
export default {"changeWrapper":"changePassword_changeWrapper__7mKrA","formWrapper":"changePassword_formWrapper__slJNI","heading":"changePassword_heading__RGX8W","sbmt":"changePassword_sbmt__rn224"};